var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.266,
    height: 52.266,
    viewBox: "0 0 52.266 52.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_87660",
    "data-name": "Path 87660",
    d: "M27.133,1A26.133,26.133,0,1,0,53.266,27.133,26.133,26.133,0,0,0,27.133,1Zm0,47.514A21.381,21.381,0,1,1,48.514,27.133,21.381,21.381,0,0,1,27.133,48.514Z",
    transform: "translate(-1 -1)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87661",
    "data-name": "Path 87661",
    d: "M15.751,20.646V7.376a2.376,2.376,0,1,0-4.751,0V21.63a2.375,2.375,0,0,0,.7,1.679l7.127,7.127a2.376,2.376,0,1,0,3.36-3.36Z",
    transform: "translate(12.757 4.503)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.25b430a6945a997b1294e693ea60546e.svg";
export { ForwardRef as ReactComponent };